import { getViewData } from './view-data';
import { logMixpanelSession, updateMixpanelSession } from './mixpanel';

class Global {
    constructor() {
        $(document).on('domReady', () => {
            new (require('./SlideMenu')).default;
            new (require('./Submenu')).default;
            this.modals();
            this.addTokenHeaders();
            this.alignTawkToIcon();
            if ($('[data-parallax]').length) {
                $(window).scroll(Global.onWindowScrollParallax);
            }

            logMixpanelSession();

            return this.showSwal();
        });

        $(document).ready(() => setTimeout(() => $('body').addClass('ready'), 10));

        $(document).on('click', '.has-submenu', (e) => {
            $(e.currentTarget).toggleClass('open');
        });
    }

    // Go to the top of the page         ...and beyond
    toInfinity() {
        return $('html, body').animate({
            scrollTop: 0,
        }, 250);
    }

    /**
     * TODO: Move into modals.js
     * @returns {jQuery}
     */
    modals() {
        // Vertically center modals on screen
        $(document).on('show.bs.modal', '.modal:not(.flex-center)', this.centerModals);
        $(document).on('fixposition', '.modal:not(.flex-center)', this.centerModals);
        // Update vertical position on resize
        $(window).on('resize', this.centerModals);

        $(document).on('hidden.bs.modal', '.modal', this.fixModalScroll);
        $(document).on('hide.bs.modal', '.modal', () => {
            setTimeout(() => {
                this.fixModalScroll();
            }, 500);
        });

        $(document).on('shown.bs.tab', '.modal:not(.flex-center) a[data-toggle="tab"]', this.centerModals);
    }

    fixModalScroll() {
        if ($('.modal:visible').length) {
            $('body').addClass('modal-open');
        }
    }

    /**
     * Function to vertically center modals
     * TODO: Change to flexbox alignment
     */
    centerModals() {
        if ($(window).width() >= 768) {
            $('.modal:not(.flex-center)').each(function(i) {
                let $clone = $(this)
                    .clone()
                    .css('display', 'block')
                    // Allow us to position the modal relative to another element
                    .appendTo(($(this).data('parent')) ? $(this).data('parent') : 'body');
                let top = Math.round(($clone.height() - $clone.find('.modal-content').height()) / 2);
                top = top > 0 ? top : 0;
                $clone.remove();
                $(this).find('.modal-content').css('margin-top', top);
            });
        }
    }

    alignTawkToIcon() {
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_API.onLoad = () => {
            const widget = $('iframe[title="chat widget"]');
            if (!widget.length) {
                return;
            }

            if (widget[0] == null || widget[1] == null) {
                return;
            }

            $(widget[1]).css({
                top: '75%',
            });
        };
        window.Tawk_API.onLoad();
    }

    static modalFix() {
        return $('html').addClass('modal-open-overflow');
    }

    static modalFixInverse() {
        return $('html').removeClass('modal-open-overflow');
    }

    static getAndroidVersion(ua) {
        ua = (ua || navigator.userAgent).toLowerCase();
        let match = ua.match(/android\s([0-9\.]*)/);
        return match ? match[1] : false;
    }

    addTokenHeaders() {
        if (!getViewData('_token')) {
            return;
        }
        // Add our token header
        return $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': getViewData('_token'),
            },
        });
    }

    fixModalBackdrop() {
        $('.modal:visible').each((i, el) => {
            let height = $(el).find('.modal-dialog').outerHeight(true);

            if (height < $(window).outerHeight(true)) {
                height = $(window).outerHeight(true);
            }

            $(el).find('.modal-backdrop').height(height);
        });
    }

    // Setup parallax based on data attributes
    static onWindowScrollParallax() {
        let $parallax = $('[data-parallax]');
        // Get the data passed in
        let data = $parallax.data('parallax');
        // The speed is a ratio of the distance scrolled
        // e.g. 0.5 would be 50% the distance of the page scroll
        let { speed } = data;

        let scrolled = $(window).scrollTop();

        let amount = Math.ceil(speed * scrolled);

        if (amount < 0) {
            amount = 0;
        }

        $parallax.css({
            transform: `translate3d(0, ${amount}px, 0)`,
        });
    }

    supports2Dtransforms() {
        let prefixes = 'transform WebkitTransform MozTransform OTransform msTransform'.split(' ');
        let div = document.createElement('div');

        return prefixes.find((prefix) => div && (div.style[prefix] !== undefined));
    }

    showSwal() {
        if (!getViewData('swal')) {
            return false;
        }

        if (!getViewData('swal.type') || !getViewData('swal.message')) {
            return false;
        }

        swal({
            title: getViewData('swal.type').replace(/^\w/, (c) => c.toUpperCase()),
            type: getViewData('swal.type'),
            text: getViewData('swal.message'),
        });
    }
}

export default new Global;
